module.exports = __webpack_public_path__ + "static/media/tcm.aa2221ff.jpg";